window.slate = window.slate || {};
window.theme = window.theme || {};
window.lazySizesConfig.expand = 1; // Expand the visual view area by 1px (default: 370-500)

// Returns true if it's a touch device
function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      // #app_back_in_stock
      if (!variant.available) {
        // Show popup if exists
        if( $('.product__bis-hidden').length ){
          // Open right modal
          //$('.modal--product').toggleClass('modal--opened');$('.product-oos').toggleClass('modal__content--opened');

          // Unfilter
          $( ".product-popup__products .collection-product__container" ).css('display', 'none');
          // Filter the right products
          $( ".product-popup__products .collection-product__container" ).filter( $( ".option--" + variant.option1 ) ).css( "display", "block" );

          //$('.product-popup__products').slick('slickFilter', '.option--' + variant.option1 ); // Filter

          if( $('.product-popup__products').children(':visible').length > 0 ){
            $('#popup-oos .product-popup__title2').hide();
            $('#popup-oos .product-popup__title').show();
          }
          else{
            $('#popup-oos .product-popup__title').hide();
            $('#popup-oos .product-popup__title2').show();
          }

          $('.product-popup__color').html(variant.option2);
          $('.product-popup__size').html(variant.option1);
        }
        else{
          BISPopover.show({variantId: variant.id}) // Trigger pop-up
        }
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * #afterpay
 *
   * @namespace product
 */

theme.Product = (function () {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartDisabled: '.product__cart-button--is-disabled',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    giftcardImageProperty: '[data-giftcard-property]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    afterpayPrice: '[data-afterpay-price]',
    productStock: '[data-product-stock]',
    productThumbs: '[data-product-single-thumbnail]',
    productOptionSelector: '[data-product-swatch-selector]',
    productOptionInput: '[data-product-swatch-input]',
    singleOptionSelector: '[data-single-option-selector]',
    sizeOptionSwatch: '[data-size-option-swatch]',
    popupSizeBtn: '[data-popup-size-btn]',
    productQuantity: '[data-product-quantity]',
    productQuantityButton: '[data-product-quantity-button]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateStockState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));

    // When a product option gets clicked
    $(selectors.productOptionSelector).on("click", function () {
      $(selectors.productOptionSelector).removeClass('btn--is-selected');
      $(this).addClass('btn--is-selected');
      
      // If is sold out
      if( $(this).parent().hasClass('product-swatch__option--is-soldout') ){
        // Show popup if exists
        if( $('.product__bis-hidden').length ){
          // Open up right modal
          $('.modal--product').toggleClass('modal--opened');$('.product-oos').toggleClass('modal__content--opened');$('body').addClass('menu-opened');
        }
        else{
          BISPopover.show() // Trigger pop-up
        }

      }
    });

    // Select the right size as an option and proceed to the cart page
    $(selectors.popupSizeBtn).on("click", function () {
      $('#popup-size').magnificPopup('close');
      var target = $(this).data('target');
      var sizeSelectorLabel = $( 'label[for=' + target + ']' );
      // If the size is available
      if( $(this).hasClass('product-swatch__option--is-available') ){
        sizeSelectorLabel.trigger('click'); // Click on the size select label
        $(selectors.addToCart).trigger('click'); // Add to cart
      }
      else{
        setTimeout(function(){
          sizeSelectorLabel.trigger('click'); // Click on the size select label, but have a delay because of the other popup
        }, 500);
      }
    });

    // Calculate OoS points
    var variants = this.variants.product.variants; // All the product variants
    var variant_sku = variants[0].sku;
    var variant_sku_base = variant_sku.substring(0, variant_sku.lastIndexOf('-'));
    var points = 0;
    for ( var i = 0; i < variants.length; i++ ) {
      let currentVariant = variants[i];
      if( !currentVariant.available ){
        switch ( currentVariant.option1 ) {
          case 'XXS':
            points += 0;
            break;
          case 'XS':
            points += 1;
            break;
          case 'S':
            points += 3;
            break;
          case 'M':
            points += 3;
            break;
          case 'L':
            points += 2;
            break;
          case 'XL':
            points += 1;
        }
      }
    }

    if( points > 0 ){
      // Send Google analytics event
      ga('send', {
        hitType: 'event',
        eventCategory: 'OutOfStock',
        eventAction: 'Viewed Product With OoS Score',
        eventLabel: variant_sku_base,
        eventValue: points,
        nonInteraction: true
      });
    }

    // Image Carousel

    /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
      var $carousel = $('.product-information__tabs');

      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() > 960) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      }
      else{
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.slick({
            infinite: true,
            dots: true,
            arrows: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 4000
          });
        }
      }

    });


    $(document).ready(function(){

      $('.loader').fadeOut(); // size guide button
      // Show more product ctas after fully loaded
      $('.product-swatch--size').fadeIn(); // Size swatches
      $('.product__cart-button').fadeIn(); // Cart button
      $('.product-sizing').fadeIn(); // size guide button
    });

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the stock limit
     *
     * @param {string} productStock - The current stock of the product
     */
    updateStockState: function (evt) {
      var variant = evt.variant;
      var stock_limit = $(selectors.productStock, this.$container).data('stock-limit');

      if( variant && variant.available && variant.inventory_quantity < stock_limit ){
        $(selectors.productStock, this.$container).show();
        $(selectors.productStock, this.$container).text('Only ' + variant.inventory_quantity + ' left!');
      }
      else{
        $(selectors.productStock, this.$container).hide();
      }

    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html($(selectors.addToCart).data('og-text'));
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html($(selectors.addToCart).data('so-text'));
      }

      if (variant && variant.featured_image) {
        $(selectors.giftcardImageProperty).val(variant.featured_image.src);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     * @param {string} afterpayPrice - The afterpay price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat).replace('.00', ''));
      $(selectors.afterpayPrice).html(slate.Currency.formatMoney( ( variant.price / 4 ), theme.moneyFormat).replace('.00', ''));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat).replace('.00', ''));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM by switching the featured image to the top for gift cards
     *
     * @param {string} variantImage - Image src URL
     * @param {string} currentImage - Image src URL without https:
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var variantDesign = variant.option2.toLowerCase().replace(/ /g,'-').replace(/'/g,'');
      var newFigure = $( '.product__figure--' + variantDesign );
      if( newFigure.length != 0 ){
        // Make the newFigure the featured image
        $('.product__figure').addClass('small--one-half large-up--one-quarter');
        newFigure.removeClass('small--one-half large-up--one-quarter');
        newFigure.prependTo('.product__photos');
        window.dispatchEvent(new Event('resize'));
        $('.product__photos').scrollLeft(0);
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $('body').addClass('menu-opened');
    $('.modal--address-add').toggleClass('modal--opened');
    $('.modal--address-add .modal__content').toggleClass('modal__content--opened');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('body').addClass('menu-opened');
    $('.modal--address-edit').toggleClass('modal--opened');
    $('.modal--address-edit .modal__content').toggleClass('modal__content--opened');
    $('.address__edit-form').addClass('hide') // Hide all forms
    $('#EditAddress_' + formId).removeClass('hide'); // Show current form
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');

    // Hide login
    $('#CustomerLoginForm').addClass('hide');
  }
})();


/**
 * Update the shipping threshold bar
 * @param {Object} cart - The cart object
 */
function updateThresholdBar(cart) {
  var goal_value = window.theme.integers.goal_value;
  var current_percentage = (cart.total_price / goal_value) * 100;
  var amount_left = goal_value - cart.total_price;

  setTimeout(function () {
    $('.shipping-bar__bg').css('width', current_percentage + '%');
  }, 1000);

  // Determine what text to display
  if( cart.total_price > goal_value ){
    $('.shipping-bar__text').html( theme.strings.shipping_bar_goal_text );
  }
  else if( cart.total_price > (goal_value / 2) ){
    $('.shipping-bar__text').html(
      'You are ' + (slate.Currency.formatMoney(amount_left, theme.moneyFormat)).replace('.00','') + ' away from free shipping!'
    );
  }
  else{
    $('.shipping-bar__text').html( theme.strings.shipping_bar_text );
  }
}

/**
 * Open a modal on the page
 * @param {string} modalClass - The modal class
 */
function openModal(modalClass) {
  $(modalClass).toggleClass('modal--opened'); // Open modal
  $('body').attr('scrollTop', $('html').scrollTop());
  setTimeout(function(){
    $('body').addClass('menu-opened');
  }, 300);
}

// Global collection carousel
function carouselInit( collection_class ){
  $(collection_class).not('.slick-initialized').slick({
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    mobileFirst: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          prevArrow: '<button type="button" title="Previous (arrow left)" class="btn btn--arrow btn--prev"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><defs><style>.cls-1{fill:#494b4c;}</style></defs><title>Left-Chevron</title><path class="cls-1" d="M17.65,22.85l-10-10a.5.5,0,0,1,0-.71l10-10,.71.71L8.71,12.5l9.65,9.65Z"/></svg></button>',
          nextArrow: '<button type="button" title="Next (arrow right)" class="btn btn--arrow btn--next"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><defs><style>.cls-1{fill:#494b4c;}</style></defs><title>Right-Chevron</title><path class="cls-1" d="M8.35,22.85l-.71-.71,9.65-9.65L7.65,2.85l.71-.71,10,10a.5.5,0,0,1,0,.71Z"/></svg></button>'
        }
      }
    ]
  });
}

// Global collection carousel desktop only
function carouselInitDesktop( collection_class ){
  $(collection_class).not('.slick-initialized').slick({
    adaptiveHeight: true,
    infinite: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<button type="button" title="Previous (arrow left)" class="btn btn--arrow btn--prev"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><defs><style>.cls-1{fill:#494b4c;}</style></defs><title>Left-Chevron</title><path class="cls-1" d="M17.65,22.85l-10-10a.5.5,0,0,1,0-.71l10-10,.71.71L8.71,12.5l9.65,9.65Z"/></svg></button>',
    nextArrow: '<button type="button" title="Next (arrow right)" class="btn btn--arrow btn--next"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><defs><style>.cls-1{fill:#494b4c;}</style></defs><title>Right-Chevron</title><path class="cls-1" d="M8.35,22.85l-.71-.71,9.65-9.65L7.65,2.85l.71-.71,10,10a.5.5,0,0,1,0,.71Z"/></svg></button>',
    responsive: [
      {
        breakpoint: 960,
        settings: "unslick"
      }
    ]
  });
}

function carouselInitSmall( collection_class ){
  $(collection_class).not('.slick-initialized').slick({
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    mobileFirst: true,
    infinite: false
  });
}

$(document).on('cart.ready', function(event, cart) {
  updateThresholdBar(cart);
});

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Return Magic
  // Show popup

  // if( theme.strings.permanent_domain == 'freddy-downunder.myshopify.com' || theme.strings.permanent_domain == 'freddy-dev-store.myshopify.com' ){
  //   $('body').on('click', '.return-maintenance', function (e) {

  //     e.preventDefault();
  
  //     $.magnificPopup.open({
  //       items: {
  //         src: '#popup-return-maintenance',
  //       },
  //       type: 'inline',
  //       fixedContentPos: true,
  //       fixedBgPos: false,
  
  //       overflowY: 'auto',
  
  //       closeBtnInside: true,
  //       preloader: false,
  
  //       midClick: true,
  //       removalDelay: 300,
  //       mainClass: 'popup-zoom-in'
  //     }); 
  
  //   });
  // }

  // #app_hotjar
  if( Cookies.get('fitfinder_size' ) != undefined ){
    setTimeout(function(){ hj('trigger', 'find-my-fit'); }, 5000);
  }

  // Close modal on X
  $('body').on('click', '.modal__close', function (e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('modal--opened');
    $('.modal__content').removeClass('modal__content--opened');
    $('body').removeClass('menu-opened');
    window.scrollTo(0, $('body').attr('scrolltop'));
  });

  // Close modal if you click outside it
  $('body').on('click', '.modal', function(e) {
    if (e.target !== this){
      return;
    }
    else{
      $(this).removeClass('modal--opened');
      $('.modal__content').removeClass('modal__content--opened');
      $('body').removeClass('menu-opened');
      window.scrollTo(0, $('body').attr('scrolltop'));
    }
  });

  // Close sub-modal if you click outside it
  $('body').on('click', '.sub-modal', function(e) {
    if (e.target !== this){
      return;
    }
    else{
      $(this).removeClass('sub-modal--opened');
      $('.modal--fitfinder .modal__inner').removeClass('menu-opened');
    }
  });

  // Close sub-modal on X
  $('body').on('click', '.sub-modal__close', function (e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('sub-modal--opened');
    $('.modal--fitfinder .modal__inner').removeClass('menu-opened');
  });

  // Close submodal
  $('.fitfinder__option').on('click', function(e) {
    $('.sub-modal').removeClass('sub-modal--opened');
    $('.modal--fitfinder .modal__inner').removeClass('menu-opened');
  });

  // FitFinder
  $('#fitfinder-url').on('click', function (e) {
    if($(this).hasClass('fitfinder__btn--disabled')){
      e.preventDefault();
      alert('Please choose from the above to see your Freddy size');
    }
    else{
      Cookies.set('fitfinder_size', $('#fitfinder-size').val(), { expires: 365, path: '/' });
      // Send to Google Analytics
      ga('send', {
        hitType: 'event',
        eventCategory: 'Fitfinder',
        eventAction: 'Done fitfinder',
        eventLabel: $('#fitfinder-size').val()
      });
    }
  });

  // Close fitfinder info on X
  $('.fitfinder__info-close').on('click', function (e) {
    e.preventDefault();
    $(this).parent().removeClass('fitfinder__info--opened');
  });

  // If any of the select 
  $( ".fitfinder__select" ).change(function() {

    var ff_size = $('#fitfinder-size').val();
    var ff_waist = $('#fitfinder-waist').val();
    var ff_length = $('#fitfinder-length').val();

    if( ff_size != null && ff_waist != null && ff_length != null ){
      $('#fitfinder-url').removeClass('fitfinder__btn--disabled');

      if( ff_size == 'size-l+curvy' || ff_size == 'size-xl+curvy' ){
        if( theme.strings.permanent_domain == 'freddyshop-com.myshopify.com'){
          $('#fitfinder-url').attr('href', '/collections/freddy-wrup-curvy-denim-and-fashion');
        }
        else{
          $('#fitfinder-url').attr('href', '/collections/freddys-newest-fit-new-freddy-wr-up-curvy');
        }
      }
      else if(ff_length == 'all' && ff_waist == 'all'){
        $('#fitfinder-url').attr('href', '/collections/freddy-wrup-pants/' + ff_size + '?sort_by=best-selling');
      }
      else if(ff_length == 'all'){
        $('#fitfinder-url').attr('href', '/collections/freddy-wrup-pants/' + ff_size + '+' + ff_waist + '?sort_by=best-selling');
      }
      else if(ff_waist == 'all'){
        $('#fitfinder-url').attr('href', '/collections/freddy-wrup-pants/' + ff_size + '+' + ff_length + '?sort_by=best-selling');
      }
      else{
        $('#fitfinder-url').attr('href', '/collections/freddy-wrup-pants/' + ff_size + '+' + ff_waist + '+' + ff_length + '?sort_by=best-selling');
      }
      
      $('.fitfinder__result').addClass('fitfinder__result--active');
      
      if(ff_size == 'size-l'){
        $('.fitfinder__result').html('Your Freddy size is L in most styles or S in our Curvy range.' );
      }
      else if(ff_size == 'size-xl'){
        $('.fitfinder__result').html('Your Freddy size is XL in most styles or M in our Curvy range.' );
      }
      else if(ff_size == 'size-l+curvy'){
        $('.fitfinder__result').html('Your Freddy size is L in our Curvy range.' );
      }
      else if(ff_size == 'size-xl+curvy'){
        $('.fitfinder__result').html('Your Freddy size is XL in our Curvy range.' );
      }
      else{
        $('.fitfinder__result').html('Your Freddy size is ' + ff_size.replace('size-', '').toUpperCase() + ' in most styles.' );
      }

    }
  });

  // Collection filter
  let filter_menu = $('.collection__filters--sticky');
  let lastScroll = 0;
  let filter_menu_height = filter_menu.outerHeight();

  var displayFilter = debounce(function() {
    const currentScroll = window.pageYOffset;

    if (currentScroll < filter_menu_height) {
      filter_menu.removeClass('collection__filters--is-hidden');
      return;
    }
    
    if (currentScroll > lastScroll) {
      // down
      filter_menu.addClass('collection__filters--is-hidden');
    } else if (currentScroll < lastScroll) {
      // up
      filter_menu.removeClass('collection__filters--is-hidden');
    }
    lastScroll = currentScroll;
  }, 100);
  
  window.addEventListener("scroll", displayFilter);

  let current_product;

  // Quick View
  $('body').on('click', '.qv-btn', function (e) {
    e.preventDefault();
    let product_handle = $(this).data('product-handle');

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Collection',
      eventAction: 'QV Click',
      eventLabel: product_handle
    });

    // If already loaded
    if( current_product != product_handle){
      $('.qv-product').empty(); // Empty div

      $('.qv-product__link').hide();
      $('.loader--collection').show(); // Show loader

      // Replace all products
      $.ajax({
        type: 		  'GET',
        dataType: 	'html',
        url: 		    '/products/' + product_handle + '?view=quickview',
        success: function( data ) {
          let filteredData = $( data ).find( '.product' ); // Get the product div
          let product_photos = $( data ).find( '.product__photos');
          let product_info = $( data ).find( '.product__info');
          let product_form = $( data ).find( '.product__form');
          let product_popup_size = $( data ).find( '.popup--size');
          $( product_photos ).appendTo( $( '.qv-product' ) );
          $( product_info ).appendTo( $( '.qv-product' ) );
          $( product_form ).appendTo( $( '.qv-product' ) );
          $( product_popup_size ).appendTo( $( '.qv-product' ) );
          $('.qv-product__link').attr('href' , '/products/' + product_handle);
          initPhotoSwipeFromDOM('.product__photos');
          
          $('.loader--collection').hide();
          $('.qv-product__link').show();
        },
        error: function( xhr ){
          console.log("An error occured: " + xhr.status + " " + xhr.statusText);
        }
      });
    }

    current_product = product_handle;
    openModal('.modal--qv');

  });

  $('body').on('click', '.qv-product__link', function (e) {

    let product_handle = $(this).attr('href');
    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Collection',
      eventAction: 'QV More Info',
      eventLabel: product_handle.replace('/products/', '')
    });
  });

  // Product Swatches 
  $(document).on('change', '[data-product-swatch-input]', function() {
    var optionIndex = $(this).closest('.product-swatch').attr('data-option-index');
    var optionValue = $(this).val();

    // If within quickview
    if ( $(this).parents(".qv-product").length == 1 ) {
      $('form')
      .find('.single-option-selector--qv')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
      console.log('within qv');
    }
    else {
      $(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
   }
  });

  // When add to cart button gets clicked
  $(document).on("click", '.product__cart-button--is-disabled' , function () {

    // Quickview click
    if($(this).hasClass('product__cart-button--qv')){
      if ($('.qv-product [data-size-option-swatch]').find('.btn--is-selected').length == 0) {
        alert('Please choose a size!');
        return false;
      }
      else{
        // Send to Google Analytics
        ga('send', {
          hitType: 'event',
          eventCategory: 'Collection',
          eventAction: 'QV ATC'
        });
      }
    }
    else{
      // If a size option isn't selected, show popup
      if ($('[data-size-option-swatch]').find('.btn--is-selected').length == 0) {

        $.magnificPopup.open({
          items: {
            src: '#popup-size',
          },
          type: 'inline',
          fixedContentPos: true,
          fixedBgPos: false,

          overflowY: 'auto',

          closeBtnInside: true,
          preloader: false,

          midClick: true,
          removalDelay: 300,
          mainClass: 'popup-zoom-in'
        });

        return false;
      }
    }

  });

  // When a product option gets clicked
  $('.modal--qv').on("click", '[data-product-swatch-selector]' , function () {
    $('[data-product-swatch-selector]').removeClass('btn--is-selected');
    $(this).addClass('btn--is-selected');
    
    // If is sold out
    if( $(this).parent().hasClass('product-swatch__option--is-soldout') ){
      $('.product__cart-button').prop('disabled', true); // Disable cart button
      $('.product__cart-button span').html($('.product__cart-button').data('so-text'));
    }
    else{
      $('.product__cart-button').prop('disabled', false); // Enable cart button
      $('.product__cart-button span').html($('.product__cart-button').data('og-text'));
    }
  });

  // Select the right size as an option and proceed to the cart page
  $(document).on("click", '[data-popup-size-btn]', function () {
    $('#popup-size').magnificPopup('close');
    var target = $(this).data('target');
    var sizeSelectorLabel = $( 'label[for=' + target + ']' );
    // If the size is available
    if( $(this).hasClass('product-swatch__option--is-available') ){
      sizeSelectorLabel.trigger('click'); // Click on the size select label
      $('[data-add-to-cart]').trigger('click'); // Add to cart
    }
    else{
      setTimeout(function(){
        sizeSelectorLabel.trigger('click'); // Click on the size select label, but have a delay because of the other popup
      }, 500);
    }
  });

  // Change variant selector
  $('.modal--qv').on('change', '[data-single-option-selector]', function(){

    let current_variant_title = '';
    let current_variant_sku = false;
    $('.modal--qv [data-single-option-selector]').each(function(index) {

      current_variant_title += this.value;
      if(index == ( $('.modal--qv [data-single-option-selector]').length - 1 )){
      }
      else{
        current_variant_title += ' / ';
      }

    });

    // Get variant from options
    $('.modal--qv [data-product-select] > option').each(function() {
      if( this.text == current_variant_title ){
        current_variant_sku = this.value;
      }
    });

    // Change variant
    if(current_variant_sku){
      $('.modal--qv [data-product-select]').val(current_variant_sku);
    }
  });

  // Navigation
  var $navbutton = $(".header-buttons__nav"); // Navigation Button
  var $searchbutton = $(".header-buttons__search"); // Search Button
  var $searchform = $(".header-search"); // Search Button
  var $linkWithMenu = $(".site-nav--has-submenu");

  // Open/ close the mmenu
  $navbutton.on("click", function (e) {
    if($('#main-menu').hasClass('site-nav--opened')){
      $('.site-nav--opened, .site-nav--has-opened').removeClass('site-nav--opened').removeClass('site-nav--has-opened'); // Close everything
      $('body').removeClass('menu-opened');
      $(this).removeClass('is-active');
      ga('send', {
        hitType: 'event',
        eventCategory: 'Header',
        eventAction: 'Closed Menu'
      });
    }
    else{
      $('#main-menu').addClass('site-nav--opened'); // Open menu
      $('body').addClass('menu-opened');
      $(this).addClass('is-active');
      ga('send', {
        hitType: 'event',
        eventCategory: 'Header',
        eventAction: 'Opened Menu'
      });
    }
  });

  $linkWithMenu.on("click", function (e) {
    var submenu = $(this).nextAll('nav:first');
    var parent = $(this).parent();

    if( $(this).hasClass('site-nav--has-opened') ){
      // Already opened
      submenu.removeClass('site-nav--opened');
      $(this).removeClass('site-nav--has-opened');
    }
    else{
      submenu.addClass('site-nav--opened');
      $(this).addClass('site-nav--has-opened');
    }

    // Menu: Touch Device on Menu item with MegaMenu Click. Necessary for iPad
    if( isTouchDevice() || ($(window).width() < 960) ){
      e.preventDefault();
    }
  });

  // Fit finder
  if (window.location.href.indexOf("#fitfinder") > -1) {
    $('.modal--fitfinder').toggleClass('modal--opened');
    $('.fitfinder__content').toggleClass('modal__content--opened');
    $('body').addClass('menu-opened');
  }

  // Search
  $searchbutton.on("click", function (e) {
    e.preventDefault();
    var active_class = 'header-search--is-active';

    if ($searchform.hasClass(active_class)) {
      $searchform.removeClass(active_class);
    }
    else {
      $searchform.addClass(active_class);
      setTimeout(function () {
        //$('.header-search__input').focus(); // Focus on Search Input (doesn't work because of searchanize)
      }, 300);
    }
  });

  // Country switcher
  $(".countries__selector").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass('countries__selector--active');
    $('.sub-modal--countries').toggleClass('sub-modal--opened');
  });

  // Cart Dropdown

  if (window.location.href.indexOf("/cart") == -1) {
  
    $('.header-buttons__cart').on("click", function (e) {

      e.preventDefault();

      if ( $('.site-nav').hasClass('site-nav--opened') ){
        // Close main menu if open:
        $('.site-nav--opened, .site-nav--has-opened').removeClass('site-nav--opened').removeClass('site-nav--has-opened');
        $('.cart-dropdown').addClass('cart-dropdown--is-active');
        $('body').addClass('menu-opened');
      }
      else if( $('.cart-dropdown').hasClass('cart-dropdown--is-active') ){
        // is opened
        $('.cart-dropdown').removeClass('cart-dropdown--is-active');
        $('body').removeClass('menu-opened');
      }
      else{
        // is closed
        $('.cart-dropdown').addClass('cart-dropdown--is-active');
        $('body').addClass('menu-opened');
      }

    });

  }

  $('.cart-dropdown__close').click(function(){
    $('.cart-dropdown').removeClass('cart-dropdown--is-active');
    $('body').removeClass('menu-opened');
  });

  // Close dropdown if you click outside it
  $('.cart-dropdown').on('click', function(e) {
    if (e.target !== this){
      return;
    }
    else{
      $(this).removeClass('cart-dropdown--is-active');
      $('body').removeClass('menu-opened');
    }
  });

  var current_url = window.location.href;
  if(current_url.indexOf('/a/returns') != -1) {
    // Returns Magic Popup #app_rm
    $.magnificPopup.open({
      items: {
        src: '#popup-rm',
      },
      type: 'inline',
      fixedContentPos: true,
      fixedBgPos: false,

      overflowY: 'auto',

      closeBtnInside: false,
      preloader: false,

      midClick: true,
      modal: true,
      removalDelay: 300,
      mainClass: 'popup-zoom-in'
    });
  }


  $( "#rm-form" ).submit(function( e ) {
    e.preventDefault();

    if($("input[name='rm_popup']:checked").val() == 'new'){
      $('#rm-form').hide();
      $('#rm-form2').show();
    }
    else if($("input[name='rm_popup']:checked").val() == 'defective'){
      $.magnificPopup.close();
    }

  });

  $( "#rm-form2" ).submit(function( e ) {
    e.preventDefault();
    if($("input[name='rm_waiver']:checked").val() == 'yes'){
      $.magnificPopup.close();
    }
    else{
      alert('You have to agree with these terms in order to proceed with your return request.');
    }
  });

  $('#rm-back').click(function(){
    $('#rm-form').show();
    $('#rm-form2').hide();
  });

  // Geolocation

  $.getJSON("//extreme-ip-lookup.com/json/?key=j9JEwp4kQ3pKKWMVBJJt",
  function(json) {

    // Get Base URL based on country code
    switch (json.countryCode){
      case 'US':
        var baseURL = 'freddystore.com';
        break;
      case 'AU':
        var baseURL = 'freddystore.com.au';
        break;
      case 'SG':
        var baseURL = 'freddystore.sg';
        break;
      case 'NZ':
        var baseURL = 'freddystore.co.nz';
        break;
    }

    // Get current country code
    switch ( theme.strings.permanent_domain ){
      case 'freddy-downunder.myshopify.com':
        var siteCode = 'au';
        break;
      case 'freddyshop-com.myshopify.com':
        var siteCode = 'us';
        break;
      case 'freddy-new-zealand.myshopify.com':
        var siteCode = 'nz';
        break;
      case 'freddy-singapore.myshopify.com':
        var siteCode = 'sg';
        break;
      case 'freddy-dev-store.myshopify.com':
        var siteCode = 'sg';
        break;
    }

    // If from the US, AUS, NZ or SG
    if( json.countryCode == 'US' || json.countryCode == 'AU' || json.countryCode == 'SG' || json.countryCode == 'NZ' ){

      // If visitor is not from the same location as site and cookie is undefined
      if( siteCode && Cookies.get('hide_popup_' + siteCode ) == undefined && siteCode.toUpperCase() != json.countryCode ){

        // set cookie to not show the popup again
        Cookies.set('hide_popup_' + siteCode, 'true', { expires: 365, path: '/' });
      
        // Show necessary Country switch text
        if(json.countryCode == 'US'){
          $('#popup-location .popup__title').html('We see that you are from the ' + json.country);
          $('#popup-location .popup__line1').html('We also have a store in the ' + json.country + '.');
        }
        else{
          $('#popup-location .popup__title').html('We see that you are from ' + json.country);
          $('#popup-location .popup__line1').html('We also have a store in ' + json.country + '.');
        }

        // Show urls to redirected site
        var storeURL = 'https://' + baseURL + '/?utm_source=geo-redirect&utm_medium=' + siteCode + '&utm_campaign=popup';
        $('#popup-location .popup__link').html(baseURL);
        $('#popup-location .popup__link').attr('href', storeURL);

        // Show popup
        $.magnificPopup.open({
          items: {
            src: '#popup-location',
          },
          type: 'inline',
          fixedContentPos: true,
          fixedBgPos: false,
  
          overflowY: 'auto',
  
          closeBtnInside: true,
          preloader: false,
  
          midClick: true,
          removalDelay: 300,
          mainClass: 'popup-zoom-in'
        }); 
      }
    }

  }
 );

  // Append the MegaMenus
  $('.megamenu').each(function () {
    var menu_name = $(this).attr('data-name'); // Get menu name
    var current_menu = $('.site-nav__link[data-name=' + menu_name + ']'); // MainMenu selector with menu name
    current_menu.after($(this)); // Append the MegaMenu after the current_menu
  });

  (function(l){var i,s={touchend:function(){}};for(i in s)l.addEventListener(i,s)})(document); // sticky hover fix in iOS

  // Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)
  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  // Collection
  $("#filter-menu-toggle").on("click", function (e) {
    e.preventDefault();
    $('body').addClass('menu-opened');
    $('.modal--filter').toggleClass('modal--opened');
    $('.filter__content').toggleClass('modal__content--opened');
    ga('send', {
      hitType: 'event',
      eventCategory: 'Collection',
      eventAction: 'Clicked on filter'
    });
  });

  // Collection
  $(".collection-filter__anchor").on("click", function (e) {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Collection',
      eventAction: 'Filtered for something',
      eventLabel: $(this).parent().data('name')
    });
  });

  // Expand QA tab
  $('[data-bb-qa]').on("click", function (e) {

    var tab_content = $(this).data('target');
    var active_class = 'bb-qa--is-active';
    var content_active_class = 'bb-qa__content--is-active';

    // hide and show the tab_content
    if ($(this).hasClass(active_class)) {
      $(this).removeClass(active_class);
      $(this).attr('aria-expanded', 'false');
      $(tab_content).removeClass(content_active_class);
    }
    else {
      $(this).addClass(active_class);
      $(this).attr('aria-expanded', 'true');
      $(tab_content).addClass(content_active_class);
    }

  });



  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');

    /**
     * Change the total line price of a product within the cart page
     * @param {Object} currentLinePrice - The current line price element
     * @param {integer} qty - The current quantity value of the line item
     * @param {integer} currentPrice - The current price of the line item
     */
    function changeTotalLinePrice(currentLinePrice, qty, currentPrice) {
      currentLinePrice.html(
        slate.Currency.formatMoney((qty * currentPrice), theme.moneyFormat)
      );
      currentLinePrice.data('price', (qty * currentPrice));
      return;
    }

    /**
     * Update the total cart price
     */
    function updateCartTotalPrice() {
      var price = $('.cart-product__line-price');
      var cart_price = $('.cart__item-subtotal');
      var total_price = 0;

      price.each(function () {
        total_price = total_price + $(this).data('price'); // Add total price with product total price
      });

      cart_price.html(
        slate.Currency.formatMoney((total_price), theme.moneyFormat)
      );
      return;
    }

    // Decrease/Increase current line item quantity
    $('.product-quantity__button', '.cart-product').on("click", function () {
      var currentProduct = $(this).closest('.cart-product');
      var currentInput = currentProduct.find('.product-quantity__input'); // Current input field element
      var qty = currentInput.val(); // Current quantity value

      var currentPrice = currentProduct.find('.cart-product__price').data('price');
      var currentLinePrice = currentProduct.find('.cart-product__line-price'); // Current Line Price Element

      if ($(this).data('func') == 'minus' && qty != 1) {
        qty--; // Decrement value
        currentInput.val(qty); // Replace value
        changeTotalLinePrice(currentLinePrice, qty, currentPrice);
        updateCartTotalPrice();
      }
      else if ($(this).data('func') == 'plus') {
        qty++; // Increment value
        currentInput.val(qty); // Replace value
        changeTotalLinePrice(currentLinePrice, qty, currentPrice);
        updateCartTotalPrice();
      }
    });

    var totalLoop = null;

    $('.product-quantity__input', '.cart-product').on("focusin", function () {
      // Check if the total line price should be changed every second
      var currentInput = $(this);
      totalLoop = setInterval(
        function () {
          var currentProduct = currentInput.closest('.cart-product');
          var qty = currentInput.val();
          var currentPrice = currentProduct.find('.cart-product__price').data('price');
          var currentLinePrice = currentProduct.find('.cart-product__line-price');

          changeTotalLinePrice(currentLinePrice, qty, currentPrice);
          updateCartTotalPrice();
        },
        1000
      );
    });

    $('.product-quantity__input', '.cart-product').on("focusout", function () {

      setTimeout(function () {
        clearInterval(totalLoop);
      }, 1000);
    });
    
    var pageTitle = document.title; // Get page title
    var itemCount = window.theme.integers.cart_items // Get items in cart
    var itemString = window.theme.strings.cart_items // Get item string

		function blurMessage()
  	{
			// If document is not focussed on
			if(!document.hasFocus())
			{
				if( itemCount > 0 )
				{
					// change text
					document.title = '(' + itemCount + ')' + ' You left ' + itemString + ' in cart!';
				}

				setTimeout(focusMessage, 2000); // Change title back to normal in 2 seconds
				setTimeout(blurMessage, 4000);	// Change title in 2 seconds
			}
		}

		function focusMessage()
  		{
        document.title = pageTitle; // Change title back to original title
		}

		// Change page title on blur
		$(window).blur(function() {
			blurMessage();
		});

		// Change page title back on focus
		$(window).focus(function() {
			focusMessage();
		});
  }

  var YTPlayer = null;

  // Global popups
  $('body').magnificPopup({
    delegate: 'a[href*="#popup-"]',
    type: 'inline',
    closeBtnInside: true,
    midClick: true,
    removalDelay: 300,
    mainClass: 'popup-zoom-in',
    callbacks: {
      beforeOpen: function() {
        var videoId = this.st.el.attr('data-video-id');
        if(videoId){
          YTPlayer = new YT.Player('yt-player', {
            height: '1280',
            width: '720',
            videoId: videoId,
            origin: 'https://' + window.location.hostname,
            playerVars: {
              html5: 1
            },
            events: {
              'onReady': function onPlayerReady(event) {
                event.target.playVideo();
              }
            }
          });
        }
      },
      open: function() {
      },
      close: function() {
        if( YTPlayer ){
          YTPlayer.destroy();
        }
      }
    }

  });

  function showOrders(){
    $('.account--intro').removeClass('account--is-active');
    $('.account-overview').removeClass('account-overview--is-active');
    $('.account--returns').removeClass('account--is-active');
    $('.account--orders').addClass('account--is-active');
    $('.account-menu').addClass('small--hide');
  }

  function showReturns(){
    $('.account--intro').removeClass('account--is-active');
    $('.account-overview').removeClass('account-overview--is-active');
    $('.account--orders').removeClass('account--is-active');
    $('.account-menu').addClass('small--hide');
    $('.account--returns').addClass('account--is-active');
    // Returns Magic Popup #app_rm
    $.magnificPopup.open({
      items: {
        src: '#popup-rm',
      },
      type: 'inline',
      fixedContentPos: true,
      fixedBgPos: false,

      overflowY: 'auto',

      closeBtnInside: false,
      preloader: false,

      midClick: true,
      modal: true,
      removalDelay: 300,
      mainClass: 'popup-zoom-in'
    });
  }

  // Account
  if (window.location.href.indexOf("#my-orders") > -1) {
    showOrders();
    $('.account-menu__link').removeClass('account-menu__link--active');
    $('.account-menu--orders').addClass('account-menu__link--active');
  }

  $('body').on('click', 'a[href="/account#my-orders"]', function (e) {
    showOrders();
  });

  $('body').on('click', '.account-menu__link', function (e) {
    $('.account-menu__link').removeClass('account-menu__link--active');
    $(this).addClass('account-menu__link--active');
  });

  if (window.location.href.indexOf("#returns") > -1) {
    showReturns();
    $('.account-menu__link').removeClass('account-menu__link--active');
    $('.account-menu--returns').addClass('account-menu__link--active');
  }

  $('body').on('click', 'a[href="/account#returns"]', function (e) {
    showReturns();
  });

  if (window.location.href.indexOf("/account/addresses") > -1) {
    $('.account-menu__link').removeClass('account-menu__link--active');
    $('.account-menu--address').addClass('account-menu__link--active');
  }

  $('body').on('click', '.order__load', function (e) {
    $(this).hide();
    $('.account__order-load-count').hide();
    $('.orders').show();
  });

  // MegaMenu Hover
  $( '.megamenu, .site-nav--has-submenu' ).hover(function() {
    $('.megamenu__shadow').addClass('megamenu__shadow--active');
  }, function(){
      $('.megamenu__shadow').removeClass('megamenu__shadow--active');
  }
  );

  // Fitfinder
  $('body').on('click', 'a[href="#fitfinder"]', function (e) {
    // Close any open modal
    $('.modal--opened').removeClass('modal--opened');
    $('.modal__content--opened').removeClass('modal__content--opened');

    // Then open fitfinder modal
    $('.modal--fitfinder').toggleClass('modal--opened');
    $('.fitfinder__content').toggleClass('modal__content--opened');
    $('body').addClass('menu-opened');
    e.preventDefault();

    ga('send', {
      hitType: 'event',
      eventCategory: 'Fitfinder',
      eventAction: 'Clicked on fitfinder',
      eventLabel: $(this).attr('class')
    });
  });

  // Live chat
  $('a[href="#live-chat"]').on('click', function (e) {
    $zopim.livechat.window.show(); // Show zopim / zendesk livechat
    e.preventDefault();
  });

  // Menu events
  $('body').on('click', '.site-nav__link, .nav-featured__item', function (e) {

    if( !$(this).hasClass('site-nav--has-submenu') ){
      $('.site-nav__link').removeClass('site-nav__link--active');
      $(this).addClass('site-nav__link--active');
    }

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Header',
      eventAction: 'Menu item click',
      eventLabel: $(this).data('name')
    });

  });

  // Netflix titles
  $('body').on('click', '.nf-collection__more', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Netflix',
      eventAction: 'Collection more click',
      eventLabel: $(this).attr('href')
    });

  });

  $('body').on('click', '.nf-title a', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Netflix',
      eventAction: 'Collection title click',
      eventLabel: $(this).attr('href')
    });

  });

  $('body').on('click', '.nf-collection__products', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Netflix',
      eventAction: 'Collection product click',
      eventLabel: $(this).attr('data-collection')
    });

  });

  $('body').on('click', '.nf-circles__banners', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Netflix',
      eventAction: 'Collection Circles click'
    });

  });

  $('body').on('click', '.nf-edit__banners', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Netflix',
      eventAction: 'Collection edit click'
    });

  });

  // BB Banner
  $('body').on('click', '.bb-banner', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Banner',
      eventAction: 'bb-banner click',
      eventLabel: $(this).attr('href')
    });

  });

  // BB 2 block
  $('body').on('click', '.bb-2blocks__block', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Banner',
      eventAction: 'bb-2block click',
      eventLabel: $(this).attr('href')
    });

  });

  // BB 3 block
  $('body').on('click', '.bb-3blocks__block', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Banner',
      eventAction: 'bb-3block click',
      eventLabel: $(this).attr('href')
    });

  });

  // Collection Availability
  $('body').on('click', '.collection-product__availability .product-swatch__selector', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Collection',
      eventAction: 'Clicked on Availability',
      eventLabel: $(this).html()
    });

  });

  $('.jdgm-preview-badge').click(function() {
    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Product',
      eventAction: 'JudgeMe Star Click'
    });
  })

  // Colour swatches
  $('body').on('click', '.color-swatches__anchor', function (e) {

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Product',
      eventAction: 'Colour swatch click',
      eventLabel: $(this).data('sku')
    });

  });

  // Facetime
  if (window.location.href.indexOf("#facetime") > -1) {
    $('.modal--facetime').toggleClass('modal--opened');
    $('body').addClass('menu-opened');
  }

  $('body').on('click', 'a[href="#facetime"]', function (e) {
    // Close any open modal
    $('.modal--opened').removeClass('modal--opened');
    $('.modal__content--opened').removeClass('modal__content--opened');

    // Then open facetime modal
    $('.modal--facetime').toggleClass('modal--opened');
    $('body').addClass('menu-opened');
    e.preventDefault();

    // Send to Google Analytics
    ga('send', {
      hitType: 'event',
      eventCategory: 'Facetime',
      eventAction: 'Clicked facetime banner',
      eventLabel: 'featurednavigation'
    });

  });
  
});
